import React, { useContext, useState } from "react";
import NavBar from "./reusable/NavBar";
import Home from "./components/Home";
import Cards from "./reusable/Cards";
import Training from "./components/Training";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import AboutUs from "./components/AboutUs";

import Footer from "./reusable/Footer";
import { FOOTER_DESC } from "./utils/constants";
import ContactForm from "./components/ContactForm";

// Import authentication components
import SignIn from "./components/SignIn";
import SignUp from "./components/SignUp";
import EmailVerificationSuccess from "./components/VerificationComponents/EmailVerificationSuccess";

import RequestCallback from "./components/RequestCallback";
import TopBar from "./reusable/TopBar";
import SignUp_Page_1 from "./components/SignUp_Page_1";
import SignIn_Page_1 from "./components/SignIn_Page_1";
import Dashboard from "./components/Dashboard/Dashboard";
import DesignPage_1 from "./components/Courses/Design/DesignPage_1";
import DesignPage_2 from "./components/Courses/Design/DesignPage_2";
import DesignPage_3 from "./components/Courses/Design/DesignPage_3";
import AgilePage_1 from "./components/Courses/Agile and Scrum/AgilePage_1";
import AgilePage_2 from "./components/Courses/Agile and Scrum/AgilePage_2";
import ForBusinesses from "./components/ForBusinesses";
import EnrollForm from "./components/EnrollForm";
import DashboardHome from "./components/Dashboard/DashboardHome";
import DashboardCourses from "./components/Dashboard/DashboardCourses";
import DashboardRecordedClasses from "./components/Dashboard/DashboardRecordedClasses";
import DashboardLiveSessions from "./components/Dashboard/DashboardLiveSessions";
import DashboardProgress from "./components/Dashboard/DashboardProgress";
import DashboardCertificates from "./components/Dashboard/DashboardCertificates";
import DashboardFeedback from "./components/Dashboard/DashboardFeedback";
import DashboardAnnouncements from "./components/Dashboard/DashboardAnnouncements";
import DashboardProfile from "./components/Dashboard/DashboardProfile";
import DashboardNavbar from "./components/Dashboard/DashboardNavbar";
import DashboardContacts from "./components/Dashboard/DashboardContacts";

import BankingPage_1 from "./components/Courses/Banking and finance/BankingPage_1";
import BankingPage_2 from "./components/Courses/Banking and finance/BankingPage_2";
import BankingPage_3 from "./components/Courses/Banking and finance/BankingPage_3";
import BankingPage_4 from "./components/Courses/Banking and finance/BankingPage_4";

import SoftwarePage_1 from "./components/Courses/Software Engineering/SoftwarePage_1";
import SoftwarePage_2 from "./components/Courses/Software Engineering/SoftwarePage_2";
import SoftwarePage_3 from "./components/Courses/Software Engineering/SoftwarePage_3";
import SoftwarePage_4 from "./components/Courses/Software Engineering/SoftwarePage_4";
import SoftwarePage_5 from "./components/Courses/Software Engineering/SoftwarePage_5";
import SoftwarePage_6 from "./components/Courses/Software Engineering/SoftwarePage_6";
import SoftwarePage_7 from "./components/Courses/Software Engineering/SoftwarePage_7";
import SoftwarePage_8 from "./components/Courses/Software Engineering/SoftwarePage_8";
import SoftwarePage_9 from "./components/Courses/Software Engineering/SoftwarePage_9";

import DataSciencePage_1 from "./components/Courses/Data science/DataSciencePage_1";
import DataSciencePage_2 from "./components/Courses/Data science/DataSciencePage_2";
import DataSciencePage_3 from "./components/Courses/Data science/DataSciencePage_3";
import DataSciencePage_4 from "./components/Courses/Data science/DataSciencePage_4";

import DigitalPage_1 from "./components/Courses/Digital Marketing/DigitalPage_1";
import DigitalPage_2 from "./components/Courses/Digital Marketing/DigitalPage_2";
import DigitalPage_3 from "./components/Courses/Digital Marketing/DigitalPage_3";
import DigitalPage_4 from "./components/Courses/Digital Marketing/DigitalPage_4";
import DigitalPage_5 from "./components/Courses/Digital Marketing/DigitalPage_5";

import CyberPage_1 from "./components/Courses/Cyber Security/CyberPage_1";
import CyberPage_2 from "./components/Courses/Cyber Security/CyberPage_2";

import CloudPage_1 from "./components/Courses/Cloud computing/CloudPage_1";

import CertificationPage_1 from "./components/Courses/Certification/CertificationPage_1";
import CertificationPage_2 from "./components/Courses/Certification/CertificationPage_2";
import CertificationPage_3 from "./components/Courses/Certification/CertificationPage_3";
import CertificationPage_4 from "./components/Courses/Certification/CertificationPage_4";
import CertificationPage_5 from "./components/Courses/Certification/CertificationPage_5";

import ForUniversities from "./components/ForUniversities";

// Restore placeholder components for missing pages
const TrainingPage = () => <div>Training Page</div>;
const CoursesPage = () => <div>Courses Page</div>;
const FrontendDevelopment = () => <div>Frontend Development Page</div>;
const MernStack = () => <div>MERN Stack Page</div>;
const FullStackDevelopment = () => <div>Full Stack Development Page</div>;
const UIUXDesign = () => <div>UI & UX Design Page</div>;
const DigitalMarketing = () => <div>Digital Marketing Page</div>;
const LongTermTrainings = () => <div>Long-Term Trainings Page</div>;
const ShortTermTrainings = () => <div>Short-Term Trainings Page</div>;

const AppRouter = () => {
  return (
    <>
      <TopBar />
      <NavBar />
      <Outlet />
      <Footer {...FOOTER_DESC} />
    </>
  );
};

// Authentication pages router - no navbar/footer
const AuthRouter = () => {
  return (
    <>
      <NavBar />
      <Outlet />
    </>
  );
};

const AppDashboard = () => {
  const [dashDropdown, setDashDropdown] = useState(false);
  return (
    <>
      <DashboardNavbar setDashDropdown={() => setDashDropdown(!dashDropdown)} />
      <div className="dashboard-overall">
        <Dashboard
          dashDropdown={dashDropdown}
          setDashDropdown={() => setDashDropdown(!dashDropdown)}
        />
        <Outlet />
      </div>
    </>
  );
};

const router = createBrowserRouter([
  {
    element: <AuthRouter />,
    children: [
      {
        element: <SignIn />,
        path: "signin",
      },
      {
        element: <SignUp />,
        path: "signup",
      },
      {
        element: <EmailVerificationSuccess />,
        path: "verify-email",
      },
    ],
  },
  {
    element: <AppRouter />,
    children: [
      {
        element: <Home />,
        path: "/",
      },
      {
        element: <Training />,
        path: "long-term-trainings",
      },
      {
        element: <Training />,
        path: "short-term-trainings",
      },
      {
        element: <AboutUs />,
        path: "AboutUs",
      },
      {
        element: <ContactForm />,
        path: "Contact",
      },
      {
        element: <BankingPage_1 />,
        path: "/banking_page-1",
      },
      {
        element: <BankingPage_2 />,
        path: "/banking_page-2",
      },
      {
        element: <BankingPage_3 />,
        path: "/banking_page-3",
      },
      {
        element: <BankingPage_4 />,
        path: "/banking_page-4",
      },
      {
        element: <SoftwarePage_1 />,
        path: "/software_page-1",
      },
      {
        element: <SoftwarePage_2 />,
        path: "/software_page-2",
      },
      {
        element: <SoftwarePage_3 />,
        path: "/software_page-3",
      },
      {
        element: <SoftwarePage_4 />,
        path: "/software_page-4",
      },
      {
        element: <SoftwarePage_5 />,
        path: "/software_page-5",
      },
      {
        element: <SoftwarePage_6 />,
        path: "/software_page-6",
      },
      {
        element: <SoftwarePage_7 />,
        path: "/software_page-7",
      },
      {
        element: <SoftwarePage_8 />,
        path: "/software_page-8",
      },
      {
        element: <SoftwarePage_9 />,
        path: "/software_page-9",
      },
      {
        element: <DataSciencePage_1 />,
        path: "/datascience_page-1",
      },
      {
        element: <DataSciencePage_2 />,
        path: "/datascience_page-2",
      },
      {
        element: <DataSciencePage_3 />,
        path: "/datascience_page-3",
      },
      {
        element: <DataSciencePage_4 />,
        path: "/datascience_page-4",
      },
      {
        element: <DigitalPage_1 />,
        path: "/digitalmarketing_page-1",
      },
      {
        element: <DigitalPage_2 />,
        path: "/digitalmarketing_page-2",
      },
      {
        element: <DigitalPage_3 />,
        path: "/digitalmarketing_page-3",
      },
      {
        element: <DigitalPage_4 />,
        path: "/digitalmarketing_page-4",
      },
      {
        element: <DigitalPage_5 />,
        path: "/digitalmarketing_page-5",
      },
      {
        element: <CyberPage_1 />,
        path: "/cyber_page-1",
      },
      {
        element: <CyberPage_2 />,
        path: "/cyber_page-2",
      },
      {
        element: <CloudPage_1 />,
        path: "/cloud_page-1",
      },
      {
        element: <CertificationPage_1 />,
        path: "/certification_page-1",
      },
      {
        element: <CertificationPage_2 />,
        path: "/certification_page-2",
      },
      {
        element: <CertificationPage_3 />,
        path: "/certification_page-3",
      },
      {
        element: <CertificationPage_4 />,
        path: "/certification_page-4",
      },
      {
        element: <CertificationPage_5 />,
        path: "/certification_page-5",
      },
      {
        element: <DesignPage_1 />,
        path: "/design_page-1",
      },
      {
        element: <DesignPage_2 />,
        path: "/design_page-2",
      },
      {
        element: <DesignPage_3 />,
        path: "/design_page-3",
      },
      {
        element: <AgilePage_1 />,
        path: "/agile_page-1",
      },
      {
        element: <AgilePage_2 />,
        path: "/agile_page-2",
      },
      {
        element: <RequestCallback />,
        path: "/request-a-callback",
      },
      {
        element: <SignIn_Page_1 />,
        path: "/signin-page1",
      },
      {
        element: <SignUp_Page_1 />,
        path: "/signUp-page1",
      },
      {
        element: <ForBusinesses />,
        path: "/for-businesses",
      },
      {
        element: <ForUniversities />,
        path: "/for-universities",
      },
      {
        element: <EnrollForm />,
        path: "/enroll-now",
      },
      {
        element: <TrainingPage />,
        path: "Training",
      },
      {
        element: <CoursesPage />,
        path: "Courses",
      },
      {
        element: <FrontendDevelopment />,
        path: "frontend development",
      },
      {
        element: <MernStack />,
        path: "mern stack",
      },
      {
        element: <FullStackDevelopment />,
        path: "full stack development",
      },
      {
        element: <UIUXDesign />,
        path: "ui&ux design",
      },
      {
        element: <DigitalMarketing />,
        path: "digital marketing",
      },
      {
        element: <LongTermTrainings />,
        path: "longterm trainings",
      },
      {
        element: <ShortTermTrainings />,
        path: "shortterm trainings",
      },
    ],
  },
  {
    element: <AppDashboard />,
    path: "dashboard",
    children: [
      {
        element: <DashboardHome />,
        path: "",
      },
      {
        element: <DashboardCourses />,
        path: "courses",
      },
      {
        element: <DashboardAnnouncements />,
        path: "announcements",
      },
      {
        element: <DashboardCertificates />,
        path: "certificates",
      },
      {
        element: <DashboardLiveSessions />,
        path: "livesessions",
      },
      {
        element: <DashboardRecordedClasses />,
        path: "recordedclasses",
      },
      {
        element: <DashboardProgress />,
        path: "progress",
      },
      {
        element: <DashboardFeedback />,
        path: "feedback",
      },
      {
        element: <DashboardProfile />,
        path: "profile",
      },
      {
        element: <DashboardContacts />,
        path: "contacts",
      },
    ],
  },
]);

const App = () => {
  return (
    <div>
      <RouterProvider router={router} />
    </div>
  );
};

export default App;
